import AuditOpen from "@/views/auditReport/index.vue";

export const auditRoutes = [
  // 开放报告
  {
    path: "/auditReport",
    component: AuditOpen,
    redirect: "/auditReport/audit-open",
    meta: {
      title: "auditReport",
    },
    children: [
      {
        path: "/auditReport/audit-open",
        name: "audit-open",
        meta: {
          title: "开放报告",
        },
        components: {
          default: () =>
            import("@/views/auditReport/audit-open/audit-open.vue"),
        },
      },
      {
        path: "/auditReport/audit-all",
        name: "audit-all",
        meta: {
          title: "全部报告",
        },
        components: {
          default: () => import("@/views/auditReport/audit-all/audit-all.vue"),
        },
      },
      {
        path: "/auditReport/audit-detail/:id",
        name: "audit-detail",
        meta: {
          title: "审计详情页",
          hideHeader: true,
        },
        component: () =>
          import("@/views/auditReport/audit-detail/audit-detail.vue"),
      },
    ],
  },
];
